module.exports = __webpack_public_path__ + "img/aj-2000-mobile.409ccdc5.jpg";